export function Timer(fn, t) {
  let timerObj = setInterval(fn, t);

  this.stop = function () {
    if (timerObj) {
      clearInterval(timerObj);
      timerObj = null;
    }

    return this;
  };

  this.start = function () {
    clearInterval(timerObj);

    if (!timerObj) {
      this.stop();
      timerObj = setInterval(fn, t);
    }

    return this;
  };

  this.reset = function (newT = t) {
    t = newT;

    return this.stop().start();
  };
}
